const byCat = (...cats) => (p) => cats.includes(p.category);
const bySlug = (...slugs) => (p) => slugs.includes(p.slug);

export const SEO_PAGES = [
  {
    key: "fournisseur",
    path: "/fournisseur-produits-coiffure-professionnels",
    title: "Fournisseur de produits de coiffure professionnels",
    image: "/img/home/pro-hero.webp",
    alt: "Salon de coiffure professionnel avec coiffeurs et barbier",
    seoTitle: "Fournisseur de produits de coiffure professionnels en France et en Belgique | Ozentya",
    seoDesc: "Ozentya, fournisseur de produits de coiffure pour salons, barbiers, coiffeurs indépendants et boutiques : prix HT, commande par conditionnement, livraison en France, DOM-TOM et Belgique.",
    h1: "Votre fournisseur de produits de coiffure professionnels",
    intro: [
      "Choisir un fournisseur, c'est d'abord pouvoir compter sur des produits disponibles, des prix clairs et une commande simple. Ozentya vend sa propre gamme de soins capillaires et barbe directement aux professionnels, sans intermédiaire.",
      "Salons afro, salons mixtes, barbershops, coiffeurs indépendants et boutiques commandent en ligne par conditionnement de 12 à 180 pièces selon les produits, avec facture et TVA calculées automatiquement.",
    ],
    points: [
      ["Prix HT affichés", "Les prix professionnels sont visibles dès que votre compte est validé, sans demande de devis préalable."],
      ["Commande au conditionnement", "Choisissez 12, 20, 24 pièces ou plus selon le produit, et combinez plusieurs lots."],
      ["France, DOM-TOM et Belgique", "Livraison offerte en métropole, tarifs fixes pour les DOM-TOM et la Belgique."],
    ],
    match: () => true,
  },
  {
    key: "grossiste",
    path: "/grossiste-cosmetiques-afro",
    title: "Grossiste en cosmétiques afro pour boutiques",
    image: "/img/home/univers-afro.webp",
    alt: "Soins capillaires pour cheveux afro et texturés",
    seoTitle: "Grossiste cosmétiques afro pour boutiques et salons | Ozentya",
    seoDesc: "Approvisionnez votre boutique de cosmétiques afro avec la gamme Ozentya : soins cheveux crépus, locks, edge control, huiles barbe. Lots de 12 à 180 pièces, prix HT, France et Belgique.",
    h1: "Grossiste en cosmétiques afro pour boutiques et revendeurs",
    intro: [
      "Une boutique de cosmétiques afro a besoin de références qui tournent : soins pour cheveux crépus et bouclés, produits pour locks, finitions et barbe. La gamme Ozentya couvre ces besoins avec des produits d'une même marque, faciles à présenter en rayon.",
      "Vous commandez par lots, vous recevez une facture professionnelle, et vous pouvez recommander votre dernier assortiment en un clic.",
    ],
    points: [
      ["Un assortiment cohérent", "Pousse et cuir chevelu, hydratation, locks, barbe : une marque unique pour un rayon lisible."],
      ["Lots adaptés au rayon", "Conditionnements de 12 à 180 pièces selon la référence."],
      ["Réassort simple", "Retrouvez vos commandes et factures dans votre compte, et relancez un réassort à l'identique."],
    ],
    match: (p) => p.universes?.includes("afro") || p.universes?.includes("barber"),
  },
  {
    key: "soins",
    path: "/soins-capillaires-professionnels",
    title: "Soins capillaires professionnels",
    image: "/img/home/univers-europeenne.webp",
    alt: "Soin capillaire réalisé au bac dans un salon",
    seoTitle: "Soins capillaires professionnels : shampoings, après-shampoings, masques | Ozentya",
    seoDesc: "Shampoings, après-shampooing, masques, crèmes et lotions pour le cuir chevelu : les soins capillaires professionnels Ozentya pour salons et coiffeurs, vendus par conditionnement à prix HT.",
    h1: "Soins capillaires professionnels pour le bac et la revente",
    intro: [
      "Le soin au bac est le moment où le client juge la qualité d'un salon. Shampoing adapté, après-shampooing qui facilite le démêlage, masque pour les cheveux abîmés, lotion pour le cuir chevelu : chaque étape compte.",
      "Ces mêmes soins se proposent ensuite à la revente pour que le client prolonge la routine chez lui.",
    ],
    points: [
      ["Shampoings", "Cactus, argan, Locks et antipelliculaire, pour chaque nature de cheveux et de cuir chevelu."],
      ["Après-shampooing et masques", "Après-shampooing ricin et jojoba, Masque Suprême réparateur, crèmes Cactus et Aloe Vera."],
      ["Traitements du cuir chevelu", "Lotion Extrême Repouss classique et cheveux fins, à appliquer sans rinçage."],
    ],
    match: byCat("Soins & hydratation", "Pousse & cuir chevelu"),
  },
  {
    key: "esthetique",
    path: "/produits-institut-beaute-esthetique",
    title: "Produits pour instituts de beauté et salons d'esthétique",
    image: "/img/pro/net-serum-anti-taches-lumina-vg.webp",
    alt: "Sérum Anti-Tâches Lumina V.G Ozentya, flacon pipette 30 ml",
    seoTitle: "Produits pour instituts de beauté et salons d'esthétique | Ozentya Pro",
    seoDesc: "Sérum Anti-Tâches Lumina V.G et soins capillaires à revendre : les produits Ozentya pour instituts de beauté et salons d'esthétique, à prix HT par conditionnement.",
    h1: "Produits pour instituts de beauté et salons d'esthétique",
    intro: [
      "Les instituts accompagnent souvent une clientèle attentive à l'éclat du teint et à la santé de ses cheveux. Ozentya propose un sérum visage ciblant l'apparence des taches pigmentaires, et des soins capillaires faciles à conseiller en complément.",
      "La gamme reste volontairement courte : uniquement des produits réellement disponibles au catalogue.",
    ],
    points: [
      ["Soin visage", "Sérum Anti-Tâches Lumina V.G 30 ml : niacinamide, alpha-arbutine et acide tranexamique."],
      ["Revente capillaire", "Shampooing à l'argan et crème Aloe Vera démêlante, pour adultes et juniors."],
      ["Commande souple", "Par 12 ou 28 pièces pour le sérum, avec facture professionnelle."],
    ],
    match: bySlug("serum-anti-taches-lumina-vg", "shampooing-argan", "creme-aloe-vera-ultra-demelante-adulte-junior"),
  },
  {
    key: "livraison",
    path: "/livraison-professionnels-france-belgique-dom-tom",
    title: "Livraison pros en France, DOM-TOM et Belgique",
    image: "/img/home/pro-hero.webp",
    alt: "Salon de coiffure professionnel",
    seoTitle: "Livraison produits de coiffure pros : France, DOM-TOM et Belgique | Ozentya",
    seoDesc: "Ozentya livre les professionnels de la coiffure et de la beauté partout en France métropolitaine (offert), dans les DOM-TOM (30 à 60 €) et en Belgique (50 € HT). Délais et conditions.",
    h1: "Livraison des professionnels en France, dans les DOM-TOM et en Belgique",
    intro: [
      "Ozentya est une boutique en ligne : nous n'avons pas de magasin ouvert au public, mais nous livrons les salons, barbershops, boutiques et instituts partout où ils exercent, de Paris à Marseille, de Lille à Toulouse, de Lyon à Bordeaux, de Nantes à Strasbourg.",
      "Les professionnels de Guadeloupe, Martinique, Guyane, La Réunion et Mayotte, ainsi que de Bruxelles, Liège, Charleroi, Namur ou Mons commandent avec le même compte et les mêmes prix.",
    ],
    points: [
      ["France métropolitaine", "Mondial Relay ou transporteur offerts. Livraison sous 10 à 15 jours, dès 300 € HT d'achat (sinon retrait au dépôt de Chatou)."],
      ["DOM-TOM", "Transporteur : 30 € jusqu'à 150 € HT d'achat, 40 € de 150 à 400 €, 60 € dès 400 €, sans TVA. Calcul automatique selon le code postal."],
      ["Belgique et Europe", "Transporteur : 50 € HT par commande vers la Belgique et les autres pays européens. Avec un numéro de TVA intracommunautaire valide (UE), la facture est établie en autoliquidation."],
    ],
    match: () => false,
  },
];
